import { GetCard } from '@web/walter-lib/api'
import { useIntl } from 'react-intl'
import cn from 'classnames'
import React from 'react'
import { lang } from './lang'

function StatusBadge({ card }: { card: GetCard }) {
    const intl = useIntl()
    let addClassName
    let text

    if (card.status === 'PENDING') {
        addClassName = 'text-text-warning bg-background-warning-alpha border border-background-warning'
        text = intl.formatMessage(lang.pending)
    } else if (card.status === 'ACTIVE') {
        addClassName = 'text-text-positive bg-background-positive-alpha border border-background-positive'
        text = intl.formatMessage(lang.active)
    } else if (card.status === 'SUSPENDED') {
        addClassName = 'text-text-negative bg-background-negative-alpha border border-background-negative'
        text = intl.formatMessage(lang.frozen)
    } else if (card.status === 'BLOCKED') {
        addClassName = 'text-text-negative bg-background-negative-alpha border border-background-negative'
        text = intl.formatMessage(lang.blocked)
    } else {
        addClassName = 'text-text-secondary bg-background-secondary-alpha border border-border-separator-alpha'
        text = intl.formatMessage(lang.failed)
    }

    return (
        <div className="flex justify-start">
            <div className={cn('text-subhead py-1 px-2 rounded-[4px]', addClassName)}>{text}</div>
        </div>
    )
}

export default StatusBadge
